export const FIXED_WORDS = ['Diabetes', 'Diabetes*'];
